import { useState } from 'react'

import { cx } from '@/Ship/Helpers/cssClass'
import { resolveUserPhotoUrl } from '@/Ship/Helpers/userPhoto'

import styles from './UserPhoto.module.css'

interface UserAvatarContentProps {
    /** Фото користувача (об'єкт з url) */
    photo: unknown
    /** Ініціали, якщо фото немає або не завантажилось */
    initials: string
}

/**
 * Вміст круглого аватара: фото, а якщо його немає або воно не завантажилось — ініціали.
 * Рамку, розмір і фон задає контейнер (блок у меню, шапка профілю тощо).
 */
export const UserAvatarContent = ({ photo, initials }: UserAvatarContentProps) => {
    const url = resolveUserPhotoUrl(photo)
    const [failedUrl, setFailedUrl] = useState<string | null>(null)

    if (!url || failedUrl === url) return <>{initials}</>

    return <img className={cx(styles, 'avatarImage')} src={url} alt="" onError={() => setFailedUrl(url)} />
}
